<!-- Search history modal -->

<div class="px-3 pb-6 pt-3">
  <div class="d-flex justify-content-between mb-3">
    <div>
      <span class="font-weight-600">
        Search History
      </span>

    </div>
    <span class="text-bluex pointer">
      <i class="far fa-times f-16" (click)="closeModal()"> </i>
    </span>
  </div>
  <div *ngIf="!historyData.length" class="wccard">
    <div class="d-flex align-items-center justify-content-center" style="height: 60vh;">
      <div>
        <div class="text-center">
          <div class="text-center mb-3">
            <img src="../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
          </div>
          <p class="f-14 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search
            to add it to your search history.</p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="historyData?.length" class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="getHistory('scroll')">
    <div *ngFor="let history of historyData; index as i" class="row mx-0 mb-3px py-3 "
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
      <div class="col bb-3px">
        <div class="row">
          <div class="col d-flex justify-content-between mb-0 px-0">
            <a data-testid="auto-app-company-insights-history-mdoal-a-1" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
              data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
              aria-controls="collapseExample">
              <div class="">
                <div class="d-flex align-items-center">
                  <span class="compnaylogoplaceholder mr-2"
                    [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                    <img [src]="history.companylogo" *ngIf="history.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!history.companylogo"></i>
                  </span>
                  <div>

                  <span *ngIf="!save" [matTooltip]="history?.name" class="f-14 text-484b59"
                    [matTooltipClass]="{ 'big-tooltip text-black': true }" matTooltipPosition="left">{{history?.name}}</span>
                    <div>
                      <span class="f-10 text-9696"> {{history?.type | titlecase}} | </span>
                <span class="f-10 text-9696">{{formatDate(history?.updatedon)}}
                </span>
                    </div>
                  </div>

                </div>

              </div>

              <div>
                <div class="col d-flex justify-content-between">
                  <p style="color: #2e93a1;" (click)="selectRecentHistory(history)">Search</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
